// Danish (Dansk)
/* eslint-disable */ 
export default {
  nav: {
    home: 'Forside',
    wall: 'Væggen',
    chat: 'Beskeder',
    groups: 'Grupper',
    users: 'Brugere',
    friends: 'Venner',
    profile: 'Min profil',
    help: 'Hjælp',
    membership: 'Medlemskab',
    logout: 'Log ud',
    login: 'Log ind'
  },
  auth: {
    loginSubtitle: 'Log ind for at fortsætte',
    email: 'E-mail',
    password: 'Adgangskode',
    noAccount: 'Har du ikke en konto?',
    createAccount: 'Opret konto',
    loginFailed: 'Login mislykkedes. Tjek din e-mail og adgangskode.',
    alreadyHaveAccount: 'Har du allerede en konto?',
    register: 'Opret konto',
    name: 'Navn',
    confirmPassword: 'Bekræft adgangskode',
    registrationSuccess: 'Konto oprettet! Du kan nu logge ind.',
    registrationFailed: 'Kunne ikke oprette konto.'
  },
  home: {
    title: 'Fællesskab',
    tagline: 'Et roligt sted på nettet – uden reklamer.',
    description: 'Del hverdagen med familie, venner og nye bekendtskaber. Ingen støj, ingen tracking, ingen data-salg.',
    features: {
      noAds: 'Reklamefri',
      simple: 'Enkel og tydelig',
      safe: 'Tryg tone + moderation'
    },
    cta: {
      openWall: 'Åbn Væggen',
      createProfile: 'Opret gratis profil',
      goToWall: 'Gå til Væggen',
      readMore: 'Læs om idéen'
    },
    pricing: 'Siden er gratis at bruge.',
    pricingDetail: 'Men servere og strøm koster en del – overvej venligst at donere - det vil holde siden i live.'
  },
  wall: {
    title: 'Væggen',
    subtitle: 'Her ser du opslag fra fællesskabet.',
    writePost: 'SKRIV PÅ VÆGGEN',
    placeholder: 'Skriv dit opslag her...',
    group: 'Gruppe',
    noGroup: 'Ingen gruppe',
    selectImage: 'Vælg billede',
    selectImages: 'Vælg billeder',
    imageHint: 'Maks {max} billeder, {size}MB pr. billede',
    imagesSelected: '{count} billeder valgt',
    noFileSelected: 'Ingen fil valgt.',
    send: 'Send',
    public: 'Offentligt',
    newPosts: '{count} nyt opslag | {count} nye opslag',
    members: 'Medlemmer',
    private: 'Privat',
    visibility: 'Synlighed'
  },
  groups: {
    title: 'Grupper',
    subtitle: 'Grupper, der giver mening – lokalt, hobby, rejser, gåture – let at følge med.',
    createGroup: 'Opret gruppe',
    allGroups: 'Alle grupper',
    myGroups: 'Mine grupper',
    searchPlaceholder: 'Søg grupper...',
    noGroups: 'Ingen grupper fundet',
    noMyGroups: 'Du er ikke medlem af nogen grupper endnu',
    groupName: 'Gruppenavn',
    description: 'Beskrivelse',
    publicGroup: 'Offentlig gruppe (alle kan se og deltage)',
    private: 'Privat',
    privateGroup: 'Privat gruppe',
    privateGroupMessage: 'Dette er en privat gruppe. Du skal have en invitation for at deltage.',
    notFound: 'Gruppe ikke fundet',
    notFoundMessage: 'Denne gruppe findes ikke eller er blevet slettet.',
    backToGroups: 'Tilbage til grupper',
    createdBy: 'Oprettet af',
    members: 'medlemmer',
    postsCount: 'opslag',
    noDescription: 'Ingen beskrivelse',
    join: 'Deltag',
    leave: 'Forlad',
    open: 'Åbn',
    leaveConfirm: 'Er du sikker på, at du vil forlade denne gruppe?',
    postsTab: 'Opslag',
    membersTab: 'Medlemmer',
    invitesTab: 'Invitationer',
    noPosts: 'Ingen opslag i denne gruppe endnu',
    newPost: 'Nyt opslag',
    joinToSee: 'Deltag i gruppen for at se opslag',
    about: 'Om gruppen',
    createdOn: 'Oprettet',
    editGroup: 'Rediger gruppe',
    deleteConfirm: 'Er du sikker på, at du vil slette denne gruppe? Alle opslag vil blive slettet.',
    setMember: 'Sæt som medlem',
    setModerator: 'Sæt som moderator',
    setAdmin: 'Sæt som admin',
    removeMember: 'Fjern fra gruppe',
    removeMemberConfirm: 'Er du sikker på, at du vil fjerne {name} fra gruppen?',
    changeCover: 'Skift coverbillede',
    invalidImageType: 'Ugyldig filtype. Vælg venligst et billede.',
    imageTooLarge: 'Billedet er for stort. Maksimum 5MB.',
    inviteMembers: 'Inviter medlemmer',
    inviteMember: 'Inviter',
    searchUsers: 'Søg brugere at invitere...',
    pendingInvites: 'Ventende invitationer',
    noInvites: 'Ingen ventende invitationer',
    inviteSent: 'Invitation sendt!',
    cancelInvite: 'Annuller invitation',
    invitedBy: 'Inviteret af',
    acceptInvite: 'Accepter',
    declineInvite: 'Afvis',
    youHaveInvite: 'Du er blevet inviteret til denne gruppe',
    visibleInFeed: "Vises i dit feed",
    hiddenFromFeedSingle: "Skjult fra dit feed",
    hiddenFromFeed: "{count} grupper skjult fra dit feed",
    member: 'Medlem',
    showAll: "Vis alle i feed",
    hideAll: "Skjul alle fra feed",
    joinToComment: 'Deltag i gruppen for at kommentere',
  },
  blog: {
    title: 'Bloggen',
    allCategories: 'Alle kategorier',
    search: 'Søg i bloggen...',
    newest: 'Nyeste',
    popular: 'Populære',
    writePost: 'Skriv indlæg',
    noPosts: 'Ingen blogindlæg endnu. Vær den første til at skrive!',
    loadMore: 'Vis flere',
    backToBlog: 'Tilbage til bloggen',
    comments: 'Kommentarer',
    noComments: 'Ingen kommentarer endnu. Start debatten!',
    writeComment: 'Skriv en kommentar...',
    writeReply: 'Skriv et svar...',
    comment: 'Kommentér',
    reply: 'Svar',
    quote: 'Citér',
    edit: 'Rediger',
    delete: 'Slet',
    report: 'Anmeld',
    reportComment: 'Anmeld kommentar',
    flagDetails: 'Beskriv problemet...',
    showReplies: 'Vis {count} svar',
    hideReplies: 'Skjul svar',
    reactionsTotal: 'reaktioner',
    editPost: 'Rediger indlæg',
    headerImage: 'Headerbillede (URL)',
    category: 'Kategori',
    postTitle: 'Titel',
    postBody: 'Indhold',
    markdownHint: 'Brug **fed** og *kursiv*. @brugernavn for at nævne nogen.',
    publish: 'Udgiv',
    update: 'Opdater',
    postNotFound: 'Blogindlæg ikke fundet',
    upload: 'Upload',
    linkUrl: 'Link (URL)',
    chooseImage: 'Vælg et billede...',
    imageLoadError: 'Billede kunne ikke indlæses',
    categoryRequired: 'Vælg en kategori',
    titleMinLength: 'Mindst 5 tegn',
    characters: 'tegn',
    minCharacters: 'Mindst {min} tegn påkrævet',
    maxCharacters: 'Maks {max} tegn tilladt',
    loginToComment: 'Log ind for at kommentere',
    categories: {
      politik: 'Politik',
      videnskab: 'Videnskab',
      sport: 'Sport',
      rejser: 'Rejser',
      gaming: 'Gaming',
      mad: 'Mad',
      klima: 'Klima',
      sundhed: 'Sundhed',
      uddannelse: 'Uddannelse',
      teknologi: 'Teknologi',
      kultur: 'Kultur',
      okonomi: 'Økonomi'
    },
    linkCopied: "Kopieret!",
    copyLink: "Kopiér link",
    reactionLike: "Synes godt om",
    reactionLove: "Elsker",
    reactionInsightful: "Indsigtsfuld",
    reactionDisagree: "Uenig",
    reactionFunny: "Sjov",
  },
  profile: {
    title: 'Min profil',
    editProfile: 'Rediger profil',
    myPosts: 'Mine opslag',
    myGroups: 'Mine grupper',
    overview: 'Oversigt',
    edit: 'Rediger',
    settings: 'Indstillinger',
    activity: 'Aktivitet',
    bio: 'Om mig',
    location: 'Lokation',
    website: 'Hjemmeside',
    birthday: 'Fødselsdag',
    interests: 'Interesser',
    joined: 'Tilmeldt',
    posts: 'Opslag',
    comments: 'Kommentarer',
    reactions: 'Reaktioner',
    privacy: 'Privatliv',
    showRealName: 'Vis rigtige navn offentligt',
    showEmail: 'Vis email offentligt',
    emailNotifications: 'Email notifikationer',
    showOnlineStatus: 'Vis online status',
    showOnlineStatusHint: 'Når slået fra, vises du som offline for andre (inkognito)',
    onlineStatus: 'Online status',
    online: 'Online',
    away: 'Væk',
    offline: 'Offline',
    lastSeen: 'Sidst set',
    changePassword: 'Skift adgangskode',
    currentPassword: 'Nuværende adgangskode',
    newPassword: 'Ny adgangskode',
    confirmPassword: 'Bekræft adgangskode',
    uploadAvatar: 'Upload profilbillede',
    changeAvatar: 'Skift profilbillede',
    removeAvatar: 'Fjern profilbillede',
    bioPlaceholder: 'Fortæl lidt om dig selv...',
    interestsPlaceholder: 'Hvad interesserer du dig for?',
    saveChanges: 'Gem ændringer',
    cancelChanges: 'Fortryd',
    profileUpdated: 'Profil opdateret!',
    passwordChanged: 'Adgangskode ændret!',
    avatarUploaded: 'Profilbillede uploadet!',
    recentPosts: 'Seneste opslag',
    recentComments: 'Seneste kommentarer',
    recentReactions: 'Seneste reaktioner',
    noPosts: 'Ingen opslag endnu',
    noComments: 'Ingen kommentarer endnu',
    noReactions: 'Ingen reaktioner endnu',
    downloadData: 'Download mine data',
    deleteAccount: 'Slet konto',
    deleteAccountWarning: 'Dette sletter permanent din konto og al data. Denne handling kan ikke fortrydes.',
    age: 'år'
  },
  common: {
    loading: 'Indlæser...',
    error: 'Der opstod en fejl',
    success: 'Succes!',
    cancel: 'Annuller',
    save: 'Gem',
    delete: 'Slet',
    edit: 'Rediger',
    post: 'Send',
    comment: 'Kommentar',
    quote: 'Citer',
    reply: 'Svar',
    confirm: 'Bekræft',
    ok: 'OK',
    data: 'Data',
    viewAll: 'Se alle',
    noComments: 'Ingen kommentarer endnu. Vær den første!',
    writeComment: 'Skriv en kommentar...',
    replyToComment: 'Svar på kommentar...',
    deleteConfirm: 'Slet dette opslag?',
    contentRequired: 'Indholdet kan ikke være tomt',
    updateFailed: 'Kunne ikke opdatere opslag',
    deleteFailed: 'Kunne ikke slette opslag',
    commentFailed: 'Kunne ikke sende kommentar'
  },
  users: {
    searchTitle: 'Find brugere',
    searchSubtitle: 'Søg efter brugere i fællesskabet',
    searchSubtitleWithCount: 'Søg blandt vores {count} brugere',
    searchPlaceholder: 'Søg efter brugernavn, navn eller email...',
    search: 'Søg',
    searchHint: 'Indtast mindst 2 tegn for at søge efter brugere',
    resultsFound: '{count} bruger(e) fundet',
    noResults: 'Ingen brugere fundet. Prøv et andet søgeord.',
    noUsers: 'Ingen brugere endnu',
    memberSince: 'Medlem siden',
    showing: 'Viser {from}-{to} af {total}',
    you: 'Dig'
  },
  friends: {
    title: 'Venner',
    subtitle: 'Hold kontakten med dine venner',
    myFriends: 'Mine venner',
    requests: 'Anmodninger',
    sent: 'Sendt',
    findFriends: 'Find venner',
    noFriends: 'Du har ingen venner endnu. Find nogen at forbinde med!',
    noRequests: 'Ingen ventende venneanmodninger',
    noSentRequests: 'Du har ikke sendt nogen venneanmodninger',
    addFriend: 'Tilføj ven',
    removeFriend: 'Fjern ven',
    remove: 'Fjern',
    removeConfirm: 'Er du sikker på, at du vil fjerne {name} som ven?',
    accept: 'Accepter',
    decline: 'Afvis',
    cancel: 'Annuller',
    friends: 'Venner',
    unfriend: 'Fjern venskab',
    requestSent: 'Anmodning sendt',
    sentOn: 'Sendt'
  },
  chat: {
    title: 'Beskeder',
    searchConversations: 'Søg i samtaler...',
    noConversations: 'Ingen samtaler endnu',
    noMessages: 'Ingen beskeder endnu',
    selectConversation: 'Vælg en samtale for at begynde at chatte',
    startNewChat: 'Start ny chat',
    searchUsers: 'Søg brugere...',
    start: 'Start',
    typeMessage: 'Skriv en besked...',
    you: 'Dig',
    image: 'Billede',
    file: 'Fil',
    today: 'I dag',
    yesterday: 'I går',
    typing: 'Skriver...',
    edited: 'redigeret',
    editHistory: 'Redigeringshistorik',
    editingMessage: 'Redigerer besked',
    deleteConfirm: 'Slet denne besked?',
    messageDeleted: 'Besked slettet',
    loadMore: 'Indlæs flere',
    fileTooLarge: 'Filen er for stor. Maksimum 2MB.',
    uploadFailed: 'Kunne ikke uploade fil',
    viewProfile: 'Se profil',
    sendMessage: 'Send besked',
    videoCall: 'Videoopkald',
    joinCall: 'Deltag',
    calling: 'Ringer op...',
    connecting: 'Forbinder...',
    expand: "Forstør",
    collapse: "Formindsk",
  },
  accessibility: {
    title: 'Indstillinger',
    colorTheme: 'Farvetema',
    fontSize: 'Skriftstørrelse',
    fontSizeHint: 'Juster tekststørrelse for nemmere læsning',
    highContrast: 'Høj kontrast',
    highContrastHint: 'Øg kontrasten for bedre synlighed',
    textToSpeech: 'Læs højt',
    textToSpeechHint: 'Få tekst læst højt',
    testSpeech: 'Test tale',
    testMessage: 'Hej! Tekst til tale virker.',
    reset: 'Nulstil',
    readAloud: 'Læs højt',
    translateTo: 'Oversæt opslag til',
    translateHint: 'Vis automatisk oversæt-knap på opslag og kommentarer',
    noTranslate: 'Ingen oversættelse',
    translate: 'Oversæt',
    showOriginal: 'Original',
    favoritGroup: 'Foretrukken gruppe',
    favoriteGroupHint: 'Vælg en gruppe, der vises som standard på væggen',
    noFavoriteGroup: 'Ingen foretrukken gruppe',
    readerMode: 'Læsevisning',
    readerModeHint: 'Vis en knap der åbner opslag i fuld skærm med stor tekst',
    fontIncrease: 'Større skrift',
    fontDecrease: 'Mindre skrift',
    prevPost: 'Forrige',
    nextPost: 'Næste',
    wrote: 'skrev',
  },
  pages: {
    lastUpdated: 'Sidst opdateret',
    notFound: 'Side ikke fundet',
    faqTitle: 'Ofte Stillede Spørgsmål',
    faqSubtitle: 'Find svar på almindelige spørgsmål',
    searchFaq: 'Søg i FAQ...',
    noFaqResults: 'Ingen resultater fundet',
    stillNeedHelp: 'Har du stadig brug for hjælp?',
    contactUs: 'Kontakt os, og vi vender tilbage hurtigst muligt.',
    sendEmail: 'Send Email'
  },
  faq: {
    title: 'Ofte Stillede Spørgsmål',
    subtitle: 'Find svar på de mest almindelige spørgsmål.',
    empty: 'Ingen FAQ tilgængelig endnu.',
    categories: {
      account: 'Konto',
      groups: 'Grupper',
      chat: 'Beskeder',
      privacy: 'Privatliv',
      settings: 'Indstillinger',
      general: 'Generelt'
    }
  },
  footer: {
    about: 'Om Os',
    terms: 'Vilkår',
    privacy: 'Privatliv',
    faq: 'FAQ'
  },
  admin: {
    title: 'Adminside',
    subtitle: 'Administrer brugere, indhold og indstillinger',
    accessDenied: 'Adgang nægtet. Du skal være administrator.',
    users: 'Brugere',
    posts: 'Opslag',
    groups: 'Grupper',
    pages: 'Sider',
    totalUsers: 'Brugere i alt',
    activeUsers: 'Aktive brugere',
    totalPosts: 'Opslag i alt',
    totalGroups: 'Grupper i alt',
    searchUsers: 'Søg brugere...',
    searchPosts: 'Søg i opslag...',
    filterByStatus: 'Filtrer efter status',
    filterByGroup: 'Filtrer efter gruppe',
    user: 'Bruger',
    email: 'Email',
    status: 'Status',
    role: 'Rolle',
    joined: 'Tilmeldt',
    actions: 'Handlinger',
    member: 'Medlem',
    viewProfile: 'Se profil',
    activate: 'Aktiver',
    deactivate: 'Deaktiver',
    block: 'Bloker',
    makeAdmin: 'Gør til admin',
    removeAdmin: 'Fjern admin',
    statusLabels: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
      blocked: 'Blokeret'
    },
    allGroups: 'Alle grupper',
    images: 'billeder',
    comments: 'kommentarer',
    reactions: 'reaktioner',
    noPosts: 'Ingen opslag fundet',
    deletePost: 'Slet opslag',
    deletePostConfirm: 'Er du sikker på, at du vil slette dette opslag? Dette kan ikke fortrydes.',
    reason: 'Årsag (valgfri)',
    groupName: 'Gruppenavn',
    type: 'Type',
    creator: 'Oprettet af',
    members: 'Medlemmer',
    created: 'Oprettet',
    public: 'Offentlig',
    private: 'Privat',
    noGroups: 'Ingen grupper fundet',
    createPage: 'Opret side',
    editPage: 'Rediger side',
    slug: 'Slug',
    locale: 'Sprog',
    pageTitle: 'Titel',
    content: 'Indhold',
    metaDescription: 'Meta beskrivelse',
    published: 'Publiceret',
    draft: 'Kladde',
    lastUpdated: 'Sidst opdateret',
    deletePage: 'Slet side',
    deletePageConfirm: 'Er du sikker på, at du vil slette siden "{title}"?',
    // FAQ
    createFaq: 'Opret FAQ',
    editFaq: 'Rediger FAQ',
    deleteFaq: 'Slet FAQ',
    deleteFaqConfirm: 'Er du sikker på, at du vil slette dette spørgsmål?',
    faqCategory: 'Kategori',
    faqCategoryHint: 'Vælg eksisterende eller skriv ny',
    faqQuestion: 'Spørgsmål',
    faqAnswer: 'Svar',
    faqUncategorized: 'Uden kategori',
    noFaqs: 'Ingen FAQ endnu',
    noFaqsHint: 'Opret dit første FAQ-spørgsmål ovenfor.',
    sortOrder: 'Rækkefølge',
  },
  kanban: {
    newTask: 'Ny opgave',
    editTask: 'Rediger opgave',
    deleteTask: 'Slet opgave',
    deleteConfirm: 'Er du sikker på at du vil slette denne opgave?',
    title: 'Titel',
    description: 'Beskrivelse',
    status: 'Status',
    priority: 'Prioritet',
    assignee: 'Tildelt',
    dueDate: 'Deadline',
    columns: {
      ideas: 'Idéer',
      todo: 'ToDo',
      inProgress: 'I gang',
      test: 'Test',
      done: 'Færdig'
    },
    // Kanban comments
    comments: "Kommentarer",
    noComments: "Ingen kommentarer endnu",
    writeComment: "Skriv en kommentar...",
    addComment: "Kommentér",
    justNow: "Lige nu",
    minutesAgo: "{n} min siden",
    hoursAgo: "{n} timer siden",
    daysAgo: "{n} dage siden",
    priorities: {
      low: 'Lav',
      medium: 'Medium',
      high: 'Høj',
      urgent: 'Haster'
    },
    today: 'I dag',
    tomorrow: 'I morgen',
    yesterday: 'I går'
  },
  validation: {
    required: 'Dette felt er påkrævet',
    email: 'Indtast en gyldig e-mail',
    maxLength: 'Maks {max} tegn',
    passwordMatch: 'Adgangskoderne skal være ens',
    maxFiles: 'Maks {max} filer',
    maxFileSize: 'Filer må maks være {max}'
  },
  editor: {
    words: 'ord',
    characters: 'tegn',
    default: 'Standard',
    bold: { tooltip: 'Fed' },
    italic: { tooltip: 'Kursiv' },
    underline: { tooltip: 'Understregning' },
    strike: { tooltip: 'Gennemstreget' },
    color: { tooltip: 'Tekstfarve' },
    highlight: { tooltip: 'Fremhævning' },
    heading: {
      tooltip: 'Overskrift',
      h1: 'Overskrift 1', h2: 'Overskrift 2', h3: 'Overskrift 3',
      h4: 'Overskrift 4', h5: 'Overskrift 5', h6: 'Overskrift 6'
    },
    paragraph: 'Brødtekst',
    link: {
      tooltip: 'Link', open: 'Åbn link', edit: 'Rediger link', unlink: 'Fjern link',
      dialog: { title: 'Indsæt link', link: 'URL', text: 'Tekst', openInNewTab: 'Åbn i ny fane', button: { apply: 'Anvend' } }
    },
    image: {
      tooltip: 'Billede',
      dialog: { title: 'Indsæt billede', tab: { upload: 'Upload', url: 'URL' }, placeholder: 'Indsæt billed-URL', button: { apply: 'Indsæt' } }
    },
    video: {
      tooltip: 'Video',
      dialog: { title: 'Indsæt video', link: 'Video-URL', button: { apply: 'Indsæt' } }
    },
    table: {
      tooltip: 'Tabel',
      menu: {
        insert_table: 'Indsæt tabel', add_column_before: 'Kolonne før', add_column_after: 'Kolonne efter',
        delete_column: 'Slet kolonne', add_row_before: 'Række før', add_row_after: 'Række efter',
        delete_row: 'Slet række', merge_cells: 'Flet celler', split_cell: 'Opdel celle', delete_table: 'Slet tabel'
      }
    },
    fullscreen: { tooltip: { fullscreen: 'Fuld skærm', exit: 'Afslut fuld skærm' } },
    undo: { tooltip: 'Fortryd' },
    redo: { tooltip: 'Gentag' }
  },
  poll: {
    poll: 'Afstemning',
    pollVoted: 'Afstemning · du har stemt',
    singleChoice: 'Enkelt valg',
    multipleChoice: 'Flere valg',
    yesNo: 'Ja / Nej',
    yes: 'Ja',
    no: 'Nej',
    votes: '{count} stemmer',
    voteNoun: 'stemmer',
    daysLeft: 'Lukker om {count}d',
    hoursLeft: 'Lukker om {count}h',
    minsLeft: 'Lukker om {count}m',
    closingSoon: 'Lukker snart',
    closed: 'Lukket',
    castYourVote: 'Afgiv din stemme',
    submitVote: 'Indsend stemme',
    changeVote: 'Skift stemme',
    addPoll: 'Tilføj afstemning',
    removePoll: 'Fjern afstemning',
    type: 'Afstemningstype',
    question: 'Stil et spørgsmål…',
    options: 'Muligheder',
    option: 'Mulighed',
    addOption: 'Tilføj mulighed',
    expiresAt: 'Luk afstemning den (valgfrit)',
  },
  "auth": {
    "resetPassword": "Nulstil adgangskode",
    "resetStep1Info": "Indtast din e-mail, så sender vi dig en kode.",
    "resetStep2Info": "Tjek din e-mail for koden og vælg en ny adgangskode.",
    "sendCode": "Send kode",
    "code": "Kode",
    "newPassword": "Ny adgangskode",
    "confirmPassword": "Bekræft adgangskode",
    "setNewPassword": "Gem ny adgangskode",
    "resetSuccess": "Din adgangskode er opdateret. Du kan nu logge ind.",
    "backToLogin": "Tilbage til login",
    "emailRequired": "Indtast venligst din e-mail",
    "codeRequired": "Indtast venligst koden",
    "passwordTooShort": "Adgangskoden skal være mindst 8 tegn",
    "passwordMismatch": "Adgangskoderne stemmer ikke overens",
    "serverError": "Der skete en fejl. Prøv igen.",
    "forgotPassword": "Glemt adgangskode?"
  }
}